import { render } from "./CreateTaxe.vue?vue&type=template&id=2f10b10a"
import script from "./CreateTaxe.vue?vue&type=script&lang=js"
export * from "./CreateTaxe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__